import { render, staticRenderFns } from "./withdraw-detail.vue?vue&type=template&id=066e3722&"
import script from "./withdraw-detail.vue?vue&type=script&lang=js&"
export * from "./withdraw-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports